customElements.define(
  "flickity-slider",
  class extends HTMLElement {
    constructor() {
      super();
      this.flickityInstance = null;
      this.url = this.dataset.url;

      this.init();
    }

    init() {
      const interval = setInterval(() => {
        if (typeof Flickity !== "undefined") {
          clearInterval(interval);
          this.setSlider();
        }
      }, 100);
    }

    setSlider() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        const slider = this.querySelector(".flickity-slider__list");
        if (slider) {
          this.flickityInstance = new Flickity(slider, {
            cellAlign: "left",
            pageDots: true,
            contains: true,
            prevNextButtons: false,
            wrapAround: false,
            freeScroll: false,
            groupCells: true,
            dragThreshold: 10,
            selectedAttraction: 0.2,
            friction: 0.8,
            cellSpacing: 8,
          });

          theme.initQuickShop();
        }
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 200px 0px",
      }).observe(this);
    }

    disconnectedCallback() {
      // Détruire l'instance Flickity lors du démontage du composant
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
    }
  },
);
